import styled, { css } from 'styled-components';
import { twoLayeredBoxShadow } from '../../commonStyles/styling';
import colors from '../../helpers/colors';
import fonts from '../../helpers/fonts';
import spacing from '../../helpers/spacing';
import { Grid } from '../Grid';

export const GridWithMargins = styled(Grid)`
  && {
    margin-top: ${spacing(4)};
    margin-bottom: ${spacing(4)};
  }
`;

export const Heading = styled.h3`
  ${fonts.headingSmall};

  margin: 0 0 ${spacing(2)};
`;

const insetWhiteBorder = css`
  position: relative;
  &::before {
    position: absolute;
    top: 2px;
    right: 2px;
    bottom: 2px;
    left: 2px;
    border: 2px solid white;
    border-radius: 3px;
    content: '';
  }
`;

export const SharingButtons = styled.div`
  margin: 0 ${spacing(-1)} 0 0;

  & > * {
    height: ${spacing(6)};
    width: ${spacing(6)};

    border-radius: 4px;

    margin: 0 ${spacing(1)} 0 0;

    // Disable browser default focus behaviour
    outline: none;

    overflow: hidden;
    &:hover img,
    &:focus-visible img {
      transform: scale(1.3);
    }

    &:hover {
      ${insetWhiteBorder};
    }

    &:focus-visible {
      box-shadow: ${twoLayeredBoxShadow(colors.neutral08, colors.core02)};
    }
  }
`;
